import VideoStyles from "@components/cms/video/video.module.css";
import React, { useState } from "react";
import { Box } from "@ui/components/layout/box/Box";
import { IconButton } from "@ui/components/forms/icon-button/IconButton";
import ReactPlayerLazy from "react-player/lazy";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { PauseIcon, PlayIcon } from "@ui/components/navigation/carousel/Icons";

export const ProductVideo = ({ productVideo, isGallery = false }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const { getMultiple } = useMicrocopy();

    const microcopies = getMultiple(CommonCMS.shared, [
        CommonCMS.video.ariaPlay,
        CommonCMS.video.ariaPause,
    ]);

    return (
        <Box
            onClick={(event) => {
                event.stopPropagation();
                setIsPlaying(!isPlaying);
            }}
            sx={{
                _hover: {
                    cursor: "pointer",
                },
                height: [isGallery ? "60%" : "100%", "100%"],
                width: isGallery ? ["100%", "50%"] : "100%",
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
            }}
        >
            <ReactPlayerLazy
                className={VideoStyles["react-player"]}
                // This data should come for product
                url={productVideo}
                height="100%"
                width="100%"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    overflow: "hidden",
                }}
                controls={false}
                playing={isPlaying}
                muted={true}
                volume={0}
                loop={true}
                playsinline={true}
                id={"product-video"}
            />

            <IconButton
                // We are removing the native controls, we need to tell to assistive technologies this button controls the video
                aria-controls="product-video"
                h="10.4"
                w="10.4"
                backdropFilter={"blur(50px)"}
                boxShadow={"0px 0px 10px 0px rgba(0, 0, 0, 0.10)"}
                bg="white"
                transition={"opacity 0.05s"}
                colorScheme="transparent"
                aria-pressed={isPlaying}
                aria-label={
                    isPlaying
                        ? microcopies[CommonCMS.video.ariaPause]
                        : microcopies[CommonCMS.video.ariaPlay]
                }
                icon={isPlaying ? <PauseIcon /> : <PlayIcon />}
                color="black"
                position={"absolute"}
                bottom={["10", "4"]}
                right={["2", "4"]}
            />
        </Box>
    );
};
